import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'oppositeValue'
})
export class OppositeValuePipe implements PipeTransform {
  transform(value: number): number {
    return value ? -value : value;
  }
}
